<template>
  <footer class="footer-box">
    <div class="footer-nav">
      <div class="logo">
        <img :src='logoImg' alt="" />
      </div>
      <nav>
        <div @click="changeNav(item)" class="item" :class="{on: activeNav === item.id}" v-for="(item, index) in nav"
          :key="index">{{item.title}}</div>
      </nav>
    </div>
    <div class="footer-menus">
      <div class="footer-contact">
        <template v-for="(item, index) in footerData.contact">
          <div :key="index" class="item first" v-if="index===0">
            <img :src="item.icon" alt="" v-if="item.icon">
            <div class="laber">{{item.laber}}</div>
            <div class="value">{{item.value}}</div>
          </div>
          <div :key="index" class="item" v-else>
            <img :src="item.icon" alt="" v-if="item.icon">
            <div class="laber">{{item.content}}</div>
            <!-- <div class="laber">{{item.laber}}</div> -->
            <!-- <div class="value">{{item.value}}</div> -->
          </div>
        </template>
      </div>
      <div class="footer-business" >
        <div class="title">业务领域</div>
        <div class="lists">
          <template v-for="(item, index) in businessList">
            <div v-if="index < 6" :key="index" class="item" @click.stop="openPage(`/business/${item.id}/${item.templateId}`)" >
              <!-- <img :src="item.icon" alt="" v-if="item.icon"> -->
              <span>{{item.title}}</span>
            </div>
          </template>
          <div class="item" @click="showCodeDialod">
            <img class="wechat-icon" src="../assets/images2/bottom_icon_wechat@2x.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <p class="icp-info" @click="openWindow(footerData.beianUrl)">
      {{footerData.beian}}
    </p>
  </footer>
</template>

<script>
	import logoImg from '@/assets/images2/header_logo@2x.png';

export default {
  name: 'footer',
  props: {
    activeNav: {
      type: String,
      default: 'index'
    },
    value: {
      type: String,
      default: 'home'
    },
    deviceType: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      nav: [
        {
          id: 'index',
          title: '首页',
          type: '',
          url: ''
        },
        {
          id: 'product',
          title: '产品中心',
          type: '',
          url: ''
        },
        {
          id: 'business',
          title: '业务领域',
          type: '',
          url: ''
        },
        {
          id: 'service',
          title: '服务网络',
          type: '',
          url: ''
        },
        {
          id: 'about',
          title: '关于奔腾达',
          type: '',
          url: ''
        },
        {
          id: 'new',
          title: '新闻中心',
          type: '',
          url: ''
        },
        {
          id: 'join',
          title: '加入我们',
          type: '',
          url: ''
        },
      ],
      productList: [
        {
          id: 1,
          titleType: '产品类型',
          title: '',
          childrens: [
            {
              id: '1-1',
              title: '产品名称',
            },
            {
              id: '1-2',
              title: '产品名称',
            },
            {
              id: '1-3',
              title: '产品名称',
            }
          ],
        },
        {
          id: '2',
          titleType: '',
          title: '产品名称',
        },
        {
          id: '3',
          titleType: '',
          title: '产品名称',
        },
        {
          id: '4',
          titleType: '产品类型',
          title: '',
          childrens: [
            {
              id: '4-1',
              title: '产品名称',
            },
            {
              id: '4-2',
              title: '产品名称',
            },
            {
              id: '4-3',
              title: '产品名称',
            }
          ],
        },
      ],
      showProduct: false,
      hoverMenu: '',
      newMenuList: [
        {
          title: '企业资讯',
          id: 'consult',
          key: '',
        },
        {
          title: '行业动态',
          id: 'business',
          key: '',
        }
      ],
      logoImg,
      footerBusiness: [],
    };
  },
  watch: {
    deviceType(val) {
      console.log('watch-- deviceType--val==', val);
    }
  },
  computed: {
    footerData() {
      return this.$store.state.footerData;
    },
    businessList() {
      return this.$store.state.businessList;
    },
    cateLists() {
      const cateLists = this.$store.state.cateLists;
      return cateLists;
    },
  },
  created() {
    console.log('footer--this.value==', this.value);
    console.log('footer--this.deviceType==', this.deviceType);
    console.log('footer--this.activeNav==', this.activeNav);
    console.log('footer--this.footerData==', this.footerData);
    console.log('footer--this.businessList==', this.businessList);
    // this.activeNav = this.value;
  },
  methods: {
    openWindow(url) {
      if (!url) {
        return;
      }
      let cur_route = this.$route.path
      if (cur_route == url) {
        return;
      }
      url = url.indexOf('https://') != 0 ? 'https://' + url : url;
      window.open(url);
    },
    openPage(url) {
      if (!url) {
        return;
      }
      window.location.href = url;
    },
    showCodeDialod() {
      this.$emit('showCodeDialod', true)
    },
    menuMouseover(menuId) {
      console.log('header--this.deviceType==', this.deviceType);
      console.log('menuMouseover--menuId==', menuId);
      // if (!['lg'].includes(this.deviceType)) {
      //   return
      // }
      this.hoverMenu = menuId;
    },
    menuMouseout(e) {
      this.hoverMenu = '';
    },
    changeNav(item) {
      console.log('changeNav--item==', item);
      console.log('changeNav--this.nav==', this.nav);
      let url = '';
      switch(item.id) {
        case 'index':
        case 'service':
        case 'about':
        case 'join':
          url = `/${item.id}`
          break;
        case 'product':
          console.log('changeNav--this.cateLists==', this.cateLists);
          let cate = this.cateLists.find(d => d.templateId != 3);
          if (cate) {
            url = `/${item.id}/cate/${cate.id}/${cate.templateId}`
          } else {
            cate = this.cateLists.find(d => d.productList.length > 0);
            url = `/${item.id}/details/${cate.productList[0].id}/${cate.productList[0].templateId}`
          }
          break;
        case 'business':
          if (this.businessList.length) {
            url = `/${item.id}/${this.businessList[0].id}/${this.businessList[0].templateId}`
          }
          break;
        case 'new':
          if (this.newMenuList.length) {
            url = `/${item.id}/${this.newMenuList[0].id}`
          }
          break;
        default:
          break;
      }
      console.log('changeNav--url==', url);
      this.openPage(url)
    },
    switchProduct(item, index) {
      console.log('switchProduct--item==', item);
      console.log('switchProduct--index==', index);
      console.log('switchProduct--this.productList==', this.productList);
      let row = JSON.parse(JSON.stringify(item));
      row.open = item.open ? false : true;
      this.$set(this.productList, index, row)
    },
  },
};
</script>

<style scoped lang="scss">
@import '../common/css/footer.scss';
</style>



// WEBPACK FOOTER //
// src/components/footer.vue